import script from "./AdminOrdersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminOrdersPage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminOrdersPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__